var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-text-field", {
    ref: "input",
    class: { "full-round": _vm.fullRound },
    attrs: {
      value: _vm.value,
      "prepend-inner-icon": _vm.icon,
      rules: _vm.rules,
      label: _vm.label,
      placeholder: _vm.placeholder,
      outlined: "",
      disabled: _vm.disabled,
      prefix: _vm.prefix,
      "error-messages": _vm.errors,
      "validate-on-blur": _vm.validateOnBlur,
      "hide-details": _vm.hideDetails,
      autofocus: _vm.autofocus,
      min: _vm.min,
      max: _vm.max,
      maxlength: _vm.phone ? "12" : _vm.zipCode ? "5" : _vm.maxlength,
      dense: _vm.dense,
      loading: _vm.loading,
      counter: _vm.counter,
      type: _vm.password
        ? _vm.show
          ? "text"
          : "password"
        : _vm.email
        ? "email"
        : _vm.number
        ? "number"
        : _vm.phone
        ? "tel"
        : "text",
      "append-icon": _vm.password
        ? _vm.show
          ? "visibility"
          : "visibility_off"
        : _vm.appendIcon,
    },
    on: {
      input: function ($event) {
        ;[_vm.$emit("input", $event)]
      },
      focus: function ($event) {
        return _vm.$emit("focus")
      },
      change: function ($event) {
        return _vm.$emit("change")
      },
      "update:error": function ($event) {
        return _vm.$emit("update:error", $event)
      },
      keydown: function ($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        )
          return null
        return _vm.submit.apply(null, arguments)
      },
      "click:append": function ($event) {
        return _vm.$emit("append")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }